// see MDN docs for further options: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat

export const formatDate = (
  date: Date,
  options: any = { dateStyle: "medium", timeStyle: "short" }
) => {
  return new Intl.DateTimeFormat("en-GB", options).format(date)
}

export const formatAppointmentDateTime = (date: Date) => {
  if (date === null || typeof date !== "object") return ""
  const dayOfMonth = date.getDate()
  const day = dayOfMonth + nth(dayOfMonth)
  const month = date.toLocaleString("default", { month: "long" })
  const time = date.toLocaleString("default", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  })
  return `${day} ${month}, ${time.replace("00:", "12:").replace(" ", "")}`
}

export const formatAppointmentDate = (date: Date) => {
  if (date === null) return ""
  const dayOfMonth = date.getDate()
  const day = dayOfMonth + nth(dayOfMonth)
  const month = date.toLocaleString("default", { month: "long" })
  const year = date.getFullYear()

  return `${day} ${month} ${year}`
}

export const formatAppointmentTime = (date: Date) => {
  if (date === null) return ""
  const time = date.toLocaleString("default", {
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h12",
  })
  return `${time.replace(" ", "")}`
}

/**
 * Formats a Date object into a full appointment date/time string
 * @param date - The Date object to format
 * @returns A formatted string in the format "Friday 29th September at 9:00am"
 */
export const formatFullAppointmentDateTime = (date: Date) => {
  if (date === null || typeof date !== "object") return ""
  const dayOfWeek = date.toLocaleString("default", { weekday: "long" })
  const dayOfMonth = date.getDate()
  const day = dayOfMonth + nth(dayOfMonth)
  const month = date.toLocaleString("default", { month: "long" })
  const time = date.toLocaleString("default", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  })
  return `${dayOfWeek} ${day} ${month} at ${time.replace("00:", "12:").replace(" ", "")}`
}

// ordinal number suffix
export const nth = (d: number) => {
  if (d > 3 && d < 21) return "th"
  switch (d % 10) {
    case 1:
      return "st"
    case 2:
      return "nd"
    case 3:
      return "rd"
    default:
      return "th"
  }
}